const multiValueFields = ['category_ids', 'major_tags', 'minor_tags', 'assistant_tags']

export function buildDailyImagePickerParams(query, page = 1) {
  const params = {...query}
  const limit = Number(params.limit) || 10
  const currentPage = Math.max(Number(page) || 1, 1)

  params.limit = limit
  params.skip = (currentPage - 1) * limit

  if (!params.id) {
    delete params.id
    params.achievement_usage = 'unassigned'
  } else {
    delete params.achievement_usage
  }

  multiValueFields.forEach((field) => {
    if (Array.isArray(params[field]) && params[field].length) {
      params[field] = params[field].join(',')
    } else {
      delete params[field]
    }
  })

  if (params.is_animated !== true && params.is_animated !== false) {
    delete params.is_animated
  }

  return params
}

export function applyDailyUpdateOrder(images, sortType) {
  const orderedIds = []

  ;(images || []).forEach((image) => {
    if (!image?.id) {
      return
    }
    if (!image.sorts) {
      image.sorts = {}
    }
    image.sorts[sortType] = orderedIds.length
    orderedIds.push(image.id)
  })

  return orderedIds
}
